module.exports = __webpack_public_path__ + "img/home4.29b765c2.jpg";